import { AxiosInstance } from "axios";

export const RegisterWalkin = (axiosInstance: AxiosInstance) => {
  const apiBaseUrlUser = "api/profile";
  return {
    getProfile: async (user?: string) => {
      return await axiosInstance
        .get(`${apiBaseUrlUser}/${user}`)
        .then((result) => result.data);
    },
  };
};
